import { Controller } from "@hotwired/stimulus"

// Lives inside the "modal" Turbo Frame. Closing = emptying the frame so the
// URL/history stays untouched. A successful form submit closes it too.
export default class extends Controller {
  connect() {
    document.body.classList.add("overflow-hidden")
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  close(event) {
    if (event) event.preventDefault()
    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.removeAttribute("src")
      frame.innerHTML = ""
    } else {
      this.element.remove()
    }
  }

  submitEnd(event) {
    if (event.detail.success) this.close()
  }
}
